// This file is auto-generated by @hey-api/openapi-ts
import { disableBasedOnObjKey, disableBasedOnValueKey, keysToCamelCase, keysToSnakeCase } from '@onefootprint/core';
import { getSessionId } from '@onefootprint/dev-tools';
import { type Config, createClient, createConfig } from './client';

const clientVersion =
  typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
    ? `frontend:${process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA}`
    : undefined;

type ExtraConfigs = {
  disableBodySnakeCaseConversion?: boolean;
  disableResponseCamelCaseConversion?: boolean;
};

// `paths` here is a literal list of JSON paths emitted at codegen time by
// `update-sdk.ts` for each request function whose response/request schema
// carries `x_fp_preserve_keys: true`. The predicate is exact-equality on
// path segments — array indices are not included.
const matchesAnyPath =
  (paths: ReadonlyArray<ReadonlyArray<string>>) =>
  (path: ReadonlyArray<string>): boolean => {
    for (const candidate of paths) {
      if (candidate.length !== path.length) continue;
      let match = true;
      for (let i = 0; i < candidate.length; i++) {
        if (candidate[i] !== path[i]) {
          match = false;
          break;
        }
      }
      if (match) return true;
    }
    return false;
  };

// Per-call response transformer factory used by the affected request
// functions in `sdk.gen.ts` — preserves the listed JSON paths verbatim
// while still camelCasing every other key in the response.
export const buildResponseTransformer =
  (paths: ReadonlyArray<ReadonlyArray<string>>) =>
  (data: unknown): Promise<unknown> =>
    Promise.resolve(
      keysToCamelCase(data, {
        disableBasedOnObjKey,
        disableBasedOnValueKey,
        skipRecurseOnPath: matchesAnyPath(paths),
      }),
    );

// Per-call body serializer factory — mirror of `buildResponseTransformer` for
// outgoing request bodies whose schemas are tagged with x_fp_preserve_keys.
export const buildBodySerializer =
  (paths: ReadonlyArray<ReadonlyArray<string>>) =>
  (body: unknown): string =>
    JSON.stringify(
      keysToSnakeCase(body as Record<string, unknown>, {
        disableBasedOnObjKey,
        disableBasedOnValueKey,
        skipRecurseOnPath: matchesAnyPath(paths),
      }),
    );

export const getRequestClient = (configOverride?: Partial<Config> & ExtraConfigs) => {
  const { headers, disableBodySnakeCaseConversion, disableResponseCamelCaseConversion, ...rest } = configOverride ?? {};
  const client = createClient(
    createConfig({
      baseUrl: typeof process !== 'undefined' ? process.env?.NEXT_PUBLIC_API_BASE_URL : undefined,
      responseTransformer: data =>
        Promise.resolve(
          disableResponseCamelCaseConversion
            ? data
            : keysToCamelCase(data, {
                disableBasedOnObjKey,
                disableBasedOnValueKey,
              }),
        ),
      throwOnError: true,
      bodySerializer: body =>
        JSON.stringify(
          disableBodySnakeCaseConversion
            ? body
            : keysToSnakeCase(body, {
                disableBasedOnObjKey,
                disableBasedOnValueKey,
              }),
        ),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Fp-Session-Id': getSessionId(),
        'X-Fp-Client-Version': clientVersion,
        ...headers,
      },
      ...rest,
    }),
  );

  client.interceptors.error.use((error, _response, _request, opts) => {
    if (error && typeof error === 'object') {
      return { ...error, requestPath: opts.url };
    }
    return { message: error, requestPath: opts.url };
  });

  return client;
};

export const client = getRequestClient();
